module.exports = __webpack_public_path__ + "static/media/search.4f0a2691.svg";